import { useRouter } from "next/router";
import { useContext, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";

/**
 * Componente para interceptar rotas protegidas contra trial expirado
 * Este componente deve ser adicionado ao _app.tsx para verificar todas as rotas
 */
export const TrialRouteGuard: React.FC = () => {
    const { user } = useContext(AuthContext);
    const router = useRouter();

    // Lista de rotas que devem ser bloqueadas para usuários com trial expirado
    const blockedRoutesForExpiredTrial = [
        "/schedule",
        "/dash_agenda",
        // Adicione outras rotas relacionadas ao agendamento aqui
    ];

    useEffect(() => {
        // Verificar se o usuário está carregado, se o trial está expirado e se a rota atual é bloqueada
        if (
            user &&
            user.trial_status === "expired" &&
            blockedRoutesForExpiredTrial.some(route => router.pathname.startsWith(route))
        ) {
            // Apenas redirecionar para a página de planos sem mostrar toast
            // O toast será exibido apenas no dashboard como componente fixo
            router.replace("/planos");
        }
    }, [user, router.pathname, router]);

    // Este componente não renderiza nada, apenas executa lógica
    return null;
};
